const getEnvVar = variable => {
  let maVar = process.env[variable]

  if (typeof window !== 'undefined') {
    maVar = window.process.env[variable]
  }

  return maVar
}

export default getEnvVar
